import { createKvSyncModule, updateFeatureFlagsPlugin } from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '@/api/kvSync.js'
import kvSyncSubscriber from '@/mqtt/kvSync'
import sentry from '@/3rd-parties/sentry'

export default {
  ...createKvSyncModule({
    getKvSyncApi,
    kvSyncMqttSubscriber: kvSyncSubscriber,
    captureException: sentry.captureException,
  }),
  plugins: [
    updateFeatureFlagsPlugin,
  ],
}
